import Link from 'next/link'

export const ViewAllSearchLink = ({ onClick, query }) => {
  return (
    <Link
      scroll={false}
      href={{
        pathname: '/search',
        query: { q: query },
      }}
      onClick={onClick}
      className="w-full py-30 text-center text-12 text-midGray underline"
    >
      View all results
    </Link>
  )
}
